import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import apiCall from '../../../apiCall';
import { baseUrl, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from './../../../../../Containers/Config/index';

import { UPDATE_LOCATION, UPDATE_LOCATION_SUCCESS, UPDATE_LOCATION_ERROR } from './../../../actionType';
import { Constant } from '../../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';

function* updateLocation({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/facilities`,
      method: 'PUT',
      headers: { Authorization: Constant?.CLIENT_TOKEN, ...customHeaders },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({ type: UPDATE_LOCATION_SUCCESS, payload: response });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({ type: UPDATE_LOCATION_ERROR, payload: response.error });
    }
  } catch (error) {
    yield put({ type: UPDATE_LOCATION_ERROR, payload: error });
  }
}

export function* watchUpdateLocation() {
  yield takeEvery(UPDATE_LOCATION, updateLocation);
}

function* updateLocationSaga() {
  yield all([fork(watchUpdateLocation)]);
}

export default updateLocationSaga;
